<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Icon } from '@smatch/cassiopeia-web-components';

    // Components
    import Footer from '../../footer/Footer.svelte';

</script>

<div id = 's8-layout-authentication'>
    <div class = 's8-wrap-main'>
        <main>
            <div class = 's8-wrap-icon'>
                <Icon key = 'smatch' />
            </div>
            <slot />
        </main>
        <Footer />
    </div>
    <div class = 's8-wrap-teaser'>
        <div class = 's8-teaser-text'>
            <div class = 's8-title'>Better.</div>
            <div class = 's8-text'>
                Source at up to 90% off purchase price, boost your sales margins and drive your business forwards.
            </div>
            <div class = 's8-title'>Faster.</div>
            <div class = 's8-text'>
                Don’t risk your business with 15 month pre-order lead times. Acquire inventory in less than 4 weeks.
            </div>
            <div class = 's8-title'>Access.</div>
            <div class = 's8-text'>
                Procure A-Brands from more than €1 billion current inventory. No listings, no shop floor invests.
            </div>
        </div>
    </div>
</div>

<style lang='postcss'>

    div#s8-layout-authentication {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        background-color: rgba(248, 248, 248, 1.00);
        container-name: layout;
        container-type: inline-size;

        div.s8-wrap-main {
            min-width: 380px;
            max-width: 480px;
            padding-top: 80px;
            flex: 1;
            display: flex;
            flex-direction: column;
            row-gap: 20px;
            overflow-y: auto;

            main {
                max-width: 340px;
                margin: 0px auto;
                flex-grow: 1;
                min-height: fit-content;

                div.s8-wrap-icon {
                    border-radius: 120px;
                    height: 60px;
                    width: 60px;

                    background-color: rgba(255, 255, 255, 1.00);
                    box-shadow: 0 1px 2px 0 rgba(39,39,17,0.06);

                    margin-bottom: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    :global(svg) {
                        height: 30px;
                    }
                }

                :global(h1) {
                    margin-bottom: 0px;
                }
            }
        }
        div.s8-wrap-teaser {
            flex: 2;
            background-color: rgba(68, 131, 95, 1.00);
            background: radial-gradient(at center, rgba(68, 131, 96, 1.0), rgba(31, 71, 48, 1.0));
            display: flex;
            justify-content: center;
            align-items: center;

            div.s8-teaser-text {
                color: rgba(255, 255, 255, 1.00);
                text-shadow: 0px 2px 4px rgba(31, 71, 48, 1.0);
                max-width: 440px;

                div.s8-title {
                    font-size: 108px;
                    font-weight: 800;
                    line-height: 1;
                }

                div.s8-text {
                    font-size: 16px;
                    line-height: 1.2;

                    &:not(:last-child) {
                        margin-bottom: 6vh;
                    }
                }
            }
        }
    }

    @container layout (max-width: 800px) {
        div#s8-layout-authentication {
            div.s8-wrap-main {
                width: 100%;
            }

            div.s8-wrap-teaser {
                display: none;
            }
        }
    }

    @media (max-height: 780px) {
        div#s8-layout-authentication {
            div.s8-wrap-main {
                padding-top: 40px;
            }
        }
    }

    @media (min-height: 780px) {
        div#s8-layout-authentication {
            div.s8-wrap-main {
                :global(h3) {
                    margin-bottom: 60px;
                }
            }
        }
    }

</style>